import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTableModule, DialogModule } from 'primeng/primeng';

import { TypeaheadSelectComponent } from './typeahead-select/typeahead-select.component';
import { EditableSelectComponent } from './editable-select/editable-select.component';
import { ToggleCheckboxComponent } from './toggle-checkbox/toggle-checkbox.component';

@NgModule({
	imports: [
	    CommonModule,
        TranslateModule,
		FormsModule,
        NgbModule,
        DataTableModule,
        DialogModule
	],
	declarations: [
	    TypeaheadSelectComponent,
        EditableSelectComponent,
        ToggleCheckboxComponent
	],
	exports: [
	    TypeaheadSelectComponent,
        EditableSelectComponent,
        ToggleCheckboxComponent
	]
})
export class SharedModule {}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/components/shared.module.ts